import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { InvertedLabPurchaseOrderForm } from "@/features/purchase-orders/purchase-order-form";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateInvertedLabPurchaseOrder = () => {
  const { salesOrderLensProductId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchSalesOrderLensProduct = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiOutletClient.get(
          `sales-order-lens-products/${salesOrderLensProductId}`
        );
        setDefaultValues({
          name: data.name,
          salesOrderLensProductId: data.id,
          note: data.note || "",
          addOn: data.salesOrderLensProductAddOns?.[0]?.name || null,
          customer: {
            id: data.salesOrder.customer.id,
            name: data.salesOrder.customer.name,
          },
          buyer: {
            id: data.salesOrder.sellerId,
            name: data.salesOrder.seller.name,
          },
          salesOrderLensProductVariants: data.salesOrderLensProductVariants.map(
            (variant) => ({
              ...variant,
              price: 0,
            })
          ),
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal membuat pesanan pembelian lensa pre-order")
        );
        navigate(-1);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSalesOrderLensProduct();
  }, [salesOrderLensProductId, showSnackbar, navigate]);

  const handleSubmit = async (formData) => {
    try {
      await apiOutletClient.post("purchase-orders/lab/inverted", formData, {
        headers: {
          "Outlet-Id": formData.sellerableId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat pesanan pembelian lensa pre-order")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pesanan Pembelian Lensa Pre-Order"
      breadcrumbs={[
        { title: "Lensa Pre-Order", path: "/procurement/purchase-orders/lab-inverted" },
        { title: "Tambah" },
      ]}
    >
      <InvertedLabPurchaseOrderForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        defaultValues={defaultValues}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Proses Pesanan Pre-Order
          </Button>
        )}
      />
    </PageContainer>
  );
};
